import { CSSProperties } from 'react';

export const centerFlex: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
